import { selectUserFormData } from "app/redux/selector";
import TitleText from "app/containers/Auth/components/TitleText";
import React from "react";
import Fields from "./Fields";
import { useDispatch, useSelector } from "react-redux";
import {
  selectButtonLoading,
  selectChangeEmailRequestId,
  selectFormValues,
  selectVerifyCodeError,
} from "app/containers/Features/containers/TeamSettings/container/MySetting/redux/selector";
import { useLocation, useNavigate } from "react-router-dom";
import { actions as appActions } from "app/redux/slice";
import {
  actions,
  reducer,
  sliceKey,
} from "app/containers/Features/containers/TeamSettings/container/MySetting/redux/slice";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import mySettingSaga from "app/containers/Features/containers/TeamSettings/container/MySetting/redux/saga";

export default function OtpVerify() {
  useInjectReducer({ key: sliceKey, reducer });
  useInjectSaga({ key: sliceKey, saga: mySettingSaga });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const formValues = useSelector(selectFormValues);
  const userInfo = useSelector(selectUserFormData);
  const loading = useSelector(selectButtonLoading);
  const verifyCodeError = useSelector(selectVerifyCodeError);
  const changeEmailRequestId = useSelector(selectChangeEmailRequestId);
  const emailFromState = (location.state as { email?: string } | null)?.email;
  const emailToVerify = emailFromState || formValues?.newEmail?.value;
  const canResend = !!emailToVerify?.trim();

  const handleResend = () => {
    if (!canResend) return;
    dispatch(
      actions.updateEmail({
        newEmail: emailToVerify.trim(),
        callback() {},
      }),
    );
  };

  const handleLogout = () => {
    dispatch(appActions.onLogout());
    navigate("/auth/login", { replace: true });
  };

  return (
    <div className="flex flex-col items-center w-full max-w-[444px] mx-auto">
      <TitleText title="Seconds to sign up!" titleClassName="!mb-0" />
      <Fields
        email={emailToVerify}
        error={verifyCodeError}
        isLoading={loading}
        onResend={handleResend}
        onLogout={handleLogout}
        onOtpSubmit={function (code: string): void {
          if (!changeEmailRequestId) return;
          dispatch(
            actions.verifyChangeEmail({
              code,
              id: changeEmailRequestId,
              callback: () => {
                dispatch(appActions.doGetMyProfile());
                dispatch(actions.clearVerifyCodeError());
                if (userInfo?.selectedTeamId) {
                  navigate(`/app/team/${userInfo.selectedTeamId}/settings`);
                }
              },
            }),
          );
        }}
      />
    </div>
  );
}
